import type {ContactCardProps} from "./types.ts";
import type {AppealContentProps} from "./types.ts";

// Поля ввода для контактной формы
export const CONTACT_CARD: ContactCardProps[] = [
    {
        type: "text",
        placeholder: "ФИО*",
        required: true,
        className: "contact-card__input"
    },
    {
        type: "email",
        placeholder: "Email*",
        required: true,
        className: "contact-card__input"
    },
    {
        type: "tel",
        placeholder: "Телефон (РФ)",
        required: false,
        pattern: "+7[0-9]{10}",
        className: "contact-card__input"
    }
];

// Декоративный текст - "переписка" для вертикального слайдера
export const APPEAL_CONTENT: AppealContentProps[] = [
    {
        name: "Алексей",
        question:
            "Здравствуйте. Уже второй раз пытаюсь оплатить квитанцию в личном кабинете, но после ввода данных карты ничего не происходит.",
        answer:
            "Добрый день, Алексей. Спасибо, что сообщили о проблеме. Мы проверили работу платёжного шлюза — действительно наблюдался временный сбой соединения.",
        thanks:
            "Проверил, теперь всё работает корректно. Хорошо, спасибо!",
    },
    {
        name: "Ирина",
        question:
            "Добрый вечер. Подскажите, как можно изменить адрес проживания в договоре?",
        answer:
            "Здравствуйте, Ирина. Изменить адрес можно дистанционно. Для этого необходимо отправить через личный кабинет фото или скан документа.",
        thanks:
            "Отлично, тогда загружу документы сегодня. Спасибо большое!",
    },
    {
        name: "Михаил",
        question:
            "Здравствуйте. В этом месяце начисления за коммунальные услуги стали значительно выше, чем обычно.",
        answer:
            "Добрый день, Михаил. Мы проверили ваши переданные показания и историю начислений.",
        thanks:
            "Понял, спасибо за разъяснение, теперь всё ясно!",
    },
    {
        name: "Ольга",
        question:
            "Добрый день. Подскажите, пожалуйста, появилась ли возможность оплачивать услуги через Google Pay?",
        answer:
            "Здравствуйте, Ольга. Да, мы недавно добавили поддержку Google Pay. Теперь вы можете выбрать этот способ оплаты в личном кабинете или мобильной версии сайта.",
        thanks:
            "Очень удобно, попробую сегодня. Спасибо!",
    },
    {
        name: "Дмитрий",
        question:
            "Добрый день. Не могу найти, где в личном кабинете нужно вводить показания счётчика.",
        answer:
            "Здравствуйте, Дмитрий. В обновлённой версии личного кабинета раздел с показаниями находится во вкладке «Услуги».",
        thanks:
            "Нашёл раздел, всё получилось. Спасибо, разобрался!",
    }
];